import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../shared/guards/auth.guards';
import { Groups } from '../security/model/groups.model';
import { PartsListComponent } from './components/list/parts-list.component';
import { PartsDetailComponent } from './components/parts-detail/parts-detail.component';

export class PartsRoutingStates {
  public static readonly LIST = {
    url: 'parts'
  };
  public static readonly EDIT = {
    url: `${PartsRoutingStates.LIST.url}/:id`
  };
  public static readonly ADD = {
    url: `${PartsRoutingStates.LIST.url}/add`
  };
}

export const PartsRoutes: Routes = [
  {
    path: PartsRoutingStates.LIST.url,
    data: {
      page: {
        title: 'Parts List'
      },
      requiresRole: [
        Groups.ASSET_ADMINISTRATOR,
        Groups.ASSET_MANAGER,
        Groups.ASSET_VIEWER
      ]
    },
    component: PartsListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: PartsRoutingStates.ADD.url,
    redirectTo: PartsRoutingStates.LIST.url,
    pathMatch: 'full'
  },
  {
    path: PartsRoutingStates.EDIT.url,
    data: {
      page: {
        title: 'Parts Edit'
      },
      requiredRole: [
        Groups.ASSET_ADMINISTRATOR,
        Groups.ASSET_MANAGER,
        Groups.ASSET_VIEWER
      ]
    },
    component: PartsDetailComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(PartsRoutes)]
})
export class PartsRoutingModule {}
